import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
    fetchPlayerIntervention,
    fetchPlayerCourse,
    fetchPlayerSamLab,
    fetchPlayerCaptoLab,
    fetchPlayerlaunch,
    fetchPlayerhack,
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay,
    fetchRangePutting,
    fetchPlayerFsIron,
    fetchPlayerFsDriver,
    fetchPlayerWedge,
    fetchPlayerSpeed,
    studentOCTBunkerPlay,
    studentOCTWedgePlay,
    studentOCTShortGame,
    studentOCTApproach,
 } from 'Actions';

 import CourseItem from './coursedata';
 import SamItem from './technology/samdata';
 import CaptoItem from './technology/captodata';
 import LongItem from './range/longdata';
 import ShortItem from './range/shortdata';
 import PuttItem from './range/puttdata';
 import LaunchItem from './technology/launchdata';
 import HackItem from './technology/hackdata';
 import IronItem from './technology/fsirondata';
 import DriverItem from './technology/fsdriverdata';
 import WedgeItem from './technology/wedgedata';
 import SpeedItem from './technology/speeddata';
 import BunkerPlay from './oncoursetest/bunker';
 import WedgePlay from './oncoursetest/wedge';
 import ShortGame from './oncoursetest/shortgame';
 import Approach from './oncoursetest/approach';

class FirstItem extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.state = {
            student: this.props.data.student,
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,
            lsttype:[],            
            viewdiv1:true,
            viewtech:false,
            viewrange:false,
            viewoncourse:false,
            viewcourse:false,
            viewsam:false,
            viewcapto:false,
            viewlaunch:false,
            viewhack:false,
            viewspeed:false,
            viewiron:false,
            viewdriver:false,
            viewwedge:false,
            viewlong:false,
            viewshort:false,            
            viewputt:false,
            viewbunker:false,
            viewcurswedge:false,
            viewcurshort:false,
            viewapproach:false,
            frmsessn:1,
            frmreport:2,
        };

        this.onFirstSection = this.onFirstSection.bind(this);
    }

    nextdiv(sel){
        this.setState({
            viewsam:false,
            viewcapto:false,
            viewlaunch:false,
            viewhack:false,
            viewspeed:false,
            viewiron:false,
            viewdriver:false,
            viewwedge:false, 
            viewlong:false,   
            viewshort:false,
            viewputt:false, 
            viewbunker:false,
            viewcurswedge:false,
            viewcurshort:false,
            viewapproach:false,
        });
        if(sel==1){
            this.setState({ 
                viewrange:false,
                viewcourse:false,
                viewoncourse:false, 
                viewtech:true,      
            });
        }else  if(sel==2){
            this.setState({ 
                viewtech:false, 
                viewcourse:false,
                viewoncourse:false, 
                viewrange:true,                     
            });
        }else  if(sel==3){

            this.handleSubmit(3, 1);
            this.setState({ 
                viewtech:false, 
                viewrange:false,
                viewoncourse:false,   
                viewcourse:true,                                  
            });
        }else  if(sel==4){

            this.handleSubmit(3, 1);
            this.setState({ 
                viewtech:false, 
                viewrange:false,   
                viewcourse:false,  
                viewoncourse:true,                                
            });
        }    
    }


    handleSubmit(selfrm, labval){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        
        this.setState({
            viewsam:false,
            viewcapto:false,
            viewlaunch:false,
            viewhack:false,
            viewiron:false,
            viewspeed:false,
            viewdriver:false,
            viewwedge:false,
            viewlong:false,   
            viewshort:false,
            viewputt:false,  
            viewbunker:false,  
            viewcurswedge:false,
            viewcurshort:false,
            viewapproach:false,
        });


        if(selfrm==1){            
            if(labval==1){
                this.props.fetchPlayerSamLab(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewsam:true,                                      
                    });        
                });
                
            }else if(labval==2){
                this.props.fetchPlayerCaptoLab(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewcapto:true,                                      
                    });        
                });
            }else if(labval==3){
                this.props.fetchPlayerlaunch(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewlaunch:true,                                      
                    });        
                });
            }else if(labval==4){
                this.props.fetchPlayerFsIron(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewiron:true,                                      
                    });        
                }); 
            }else if(labval==5){
                this.props.fetchPlayerFsDriver(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewdriver:true,                                      
                    });        
                }); 
            }else if(labval==6){
                this.props.fetchPlayerWedge(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewwedge:true,                                      
                    });        
                });            
            }else if(labval==7){
                this.props.fetchPlayerhack(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewhack:true,                                      
                    });        
                });
            }else if(labval==8){
                this.props.fetchPlayerSpeed(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:1,
                        viewtech:false, 
                        viewspeed:true,                                      
                    });        
                });
            }
        }else if(selfrm==2){            

            if(labval==1){
                this.props.fetchRangeIronPlay(student, stdate, eddate);
                this.props.fetchRangeFairway(student, stdate, eddate);
                this.props.fetchRangeDriver(student, stdate, eddate);
                    this.setState({ 
                        frmsessn:2,
                        viewrange:false, 
                        viewlong:true,                                      
                    });        
                
                
            }else if(labval==2){
                this.props.fetchRangeWedgePlay(student, stdate, eddate);
                this.props.fetchRangeChipping(student, stdate, eddate);
                this.props.fetchRangeBunkerPlay(student, stdate, eddate);
                this.setState({ 
                    frmsessn:2,
                    viewrange:false, 
                    viewshort:true,                                      
                }); 
            }else if(labval==3){
                this.props.fetchRangePutting(student, stdate, eddate);
                this.setState({ 
                    frmsessn:2,
                    viewrange:false, 
                    viewputt:true,                                      
                }); 
            }
        }else if(selfrm==3){ 
            this.props.fetchPlayerCourse(student, stdate, eddate);
        }else if(selfrm==4){  
            if(labval==1){            
                this.props.studentOCTBunkerPlay(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:4,
                        viewoncourse:false,
                        viewbunker:true,                                      
                    });        
                });

            }else if(labval==2){
                this.props.studentOCTWedgePlay(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:4,
                        viewoncourse:false,
                        viewcurswedge:true,                                      
                    });        
                });
            }else if(labval==3){
                this.props.studentOCTShortGame(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:4,
                        viewoncourse:false,
                        viewcurshort:true,                                      
                    });        
                });
            }else if(labval==4){
                this.props.studentOCTApproach(student, stdate, eddate).then((data) => { 
                    this.setState({ 
                        frmsessn:4,
                        viewoncourse:false,
                        viewapproach:true,                                      
                    });        
                });
            }
        }

    }

    onFirstSection(){
        var sessn=this.state.frmsessn;
        if(sessn==1){
            this.setState({
                viewsam:false,
                viewcapto:false,
                viewlaunch:false,
                viewhack:false,
                viewiron:false,
                viewdriver:false,
                viewwedge:false,
                viewtech:true,  
            }); 
        }else if(sessn==2){
            this.setState({
                viewlong:false,
                viewshort:false,
                viewputt:false,
                viewrange:true,  
                
            }); 
        }else if(sessn==4){
            this.setState({
                viewbunker:false,
                viewcurswedge:false,
                viewoncourse:true,  
                
            }); 
        }
    }


render() {

    const { playerinterventionlist, loading} = this.props;   

     
      return(
        <div>
                {this.state.viewdiv1 &&
                    <div className="row" style={{margin:"0 auto"}}>
                        <div className="col-md-3">
                            <a onClick={ ()=>this.nextdiv(1)} >
                            <div className="w-100 mx-15 mb-15 px-20 py-15 bg-danger border-rad-md">
                                <div className='row'>
                                    <div className="col-md-2">
                                        <span className="material-icons text-white text-center" style={{fontSize:"50px"}}>{'pages'}</span>
                                    </div>
                                    <div className="col-md-10">
                                        <h2 className="text-white text-center"> Technology Report</h2>
                                        <h1 className="text-white text-center">{playerinterventionlist.technology.total}</h1>
                                    </div>
                                </div>                                
                            </div>
                            </a>
                        </div>
                        <div className="col-md-3">   
                            <a onClick={ ()=>this.nextdiv(2)} > 
                            <div className="w-100 mx-15 mb-15 px-20 py-15 bg-success border-rad-md">
                                <div className='row'>
                                    <div className="col-md-2">
                                        <span className="material-icons text-white text-center" style={{fontSize:"50px"}}>{'photo_album'}</span>
                                    </div>
                                    <div className="col-md-10">
                                        <h2 className="text-white text-center"> Range Intervention</h2>
                                        <h1 className="text-white text-center">{playerinterventionlist.range.total}</h1>
                                    </div>
                                </div>                                
                            </div>
                            </a>
                        </div>
                        <div className="col-md-3">   
                            <a onClick={ ()=>this.nextdiv(3)} > 
                            <div className="w-100 mx-15 mb-15 px-20 py-15 bg-warning border-rad-md">
                                <div className='row'>
                                    <div className="col-md-2">
                                        <span className="material-icons text-white text-center" style={{fontSize:"50px"}}>{'markunread_mailbox'}</span>
                                    </div>
                                    <div className="col-md-10">
                                        <h2 className="text-white text-center"> Course Intervention</h2>
                                        <h1 className="text-white text-center">{playerinterventionlist.course.total}</h1>
                                    </div>
                                </div>                                
                            </div>
                            </a>
                        </div>
                        <div className="col-md-3">   
                            <a onClick={ ()=>this.nextdiv(4)} > 
                            <div className="w-100 mx-15 mb-15 px-20 py-15 bg-info border-rad-md">
                                <div className='row'>
                                    <div className="col-md-2">
                                        <span className="material-icons text-white text-center" style={{fontSize:"50px"}}>{'more'}</span>
                                    </div>
                                    <div className="col-md-10">
                                        <h2 className="text-white text-center"> On Course Test</h2>
                                        <h1 className="text-white text-center">{playerinterventionlist.oncoursetest.total}</h1>
                                    </div>
                                </div>                                
                            </div>
                            </a>
                        </div>
                        </div>
                    }

                    {this.state.viewtech &&
                      <>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <h1 className="text-center" style={{padding:"20px"}}> Technology Report</h1>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="row">
                                   
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,1)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.sam}</h1>
                                                <h2 className="text-center">SAM LAB SESSION</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,2)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.capto}</h1>
                                                <h2 className="text-center">CAPTO PUTTING EVALUATION</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,3)} >  
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.launch}</h1>
                                                <h2 className="text-center">LAUNCH MONITOR SESSION</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                         <a onClick={ ()=>this.handleSubmit(1,4)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.iron}</h1>
                                                <h2 className="text-center">FS IRONS</h2>
                                            </div>
                                        </div>
                                        </a> 
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,5)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.driver}</h1>
                                                <h2 className="text-center">FS DRIVER</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div>
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,6)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.wedgeplay}</h1>
                                                <h2 className="text-center">FS WEDGE PLAY</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,7)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.hack}</h1>
                                                <h2 className="text-center">HACKMOTION SESSION</h2>
                                            </div>
                                        </div>
                                        </a> 
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(1,8)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon google`}><i className={`google ti-flickr-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.technology.speed}</h1>
                                                <h2 className="text-center">SPEED CHECK</h2>
                                            </div>
                                        </div>
                                        </a> 
                                    </div> 
                            </div>
                        </div>    
                     </>
                    }

                    {this.state.viewrange &&
                      <>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <h1 className="text-center" style={{padding:"20px"}}> Range Intervention</h1>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(2,1)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon twitter`}><i className={`twitter ti-layout-grid2-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.range.longgame}</h1>
                                                <h2 className="text-center">LONG GAME</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(2,2)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon twitter`}><i className={`twitter ti-layout-grid2-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.range.shortgame}</h1>
                                                <h2 className="text-center">SHORT GAME</h2>
                                            </div>
                                        </div>
                                        </a> 
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(2,3)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon twitter`}><i className={`twitter ti-layout-grid2-alt`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.range.putting}</h1>
                                                <h2 className="text-center">PUTTING</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    
                            </div>
                        </div>    
                     </>
                    }

                    {this.state.viewoncourse &&
                      <>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <h1 className="text-center" style={{padding:"20px"}}> On Course test</h1>
                        </div>
                        <div className="col-md-12 col-lg-12 col-sm-12">
                            <div className="row">
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(4,1)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon linkedin`}><i className={`linkedin ti-trello`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.oncoursetest.bunker}</h1>
                                                <h2 className="text-center">BUNKER PLAY</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(4,2)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon linkedin`}><i className={`linkedin ti-trello`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.oncoursetest.wedge}</h1>
                                                <h2 className="text-center">WEDGE PLAY</h2>
                                            </div>
                                        </div>
                                        </a> 
                                    </div> 
                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(4,3)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon linkedin`}><i className={`linkedin ti-trello`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.oncoursetest.shortgame}</h1>
                                                <h2 className="text-center">SHORT GAME TEST</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 

                                    <div className="col-sm-6 col-md-4 col-lg-4 w-xs-half-block">
                                        <a onClick={ ()=>this.handleSubmit(4,4)} > 
                                        <div className="social-card">
                                            <span className={`rounded-circle social-icon linkedin`}><i className={`linkedin ti-trello`}></i></span>
                                            <div>
                                                <h1 className="text-center">{playerinterventionlist.oncoursetest.approach}</h1>
                                                <h2 className="text-center">APPROACH TEST</h2>
                                            </div>
                                        </div> 
                                        </a>
                                    </div> 
                                    
                            </div>
                        </div>    
                     </>
                    }

                    

                    {this.state.viewsam &&
                   
                        <SamItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewcapto &&
                   
                        <CaptoItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewlaunch &&
                   
                        <LaunchItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewiron &&
                   
                        <IronItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewdriver &&
                   
                        <DriverItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewwedge &&
                   
                        <WedgeItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewhack &&
                   
                        <HackItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewspeed &&
                   
                        <SpeedItem data={this.state} onClick={this.onFirstSection} />
                    }


                    {/* Range Intervention */}
                    {this.state.viewlong &&                   
                        <LongItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewshort &&                   
                        <ShortItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {this.state.viewputt &&                   
                        <PuttItem data={this.state} onClick={this.onFirstSection} />
                    }

                    {/* Course Intervention */}
                    {this.state.viewcourse &&                   
                        <CourseItem data={this.state} />
                    }

                    {/* Oncourse test  */}
                    {this.state.viewbunker &&
                        <BunkerPlay data={this.state} onClick={this.onFirstSection}/>
                    }

                    {this.state.viewcurswedge &&
                        <WedgePlay data={this.state} onClick={this.onFirstSection}/>
                    }

                    {this.state.viewcurshort &&
                        <ShortGame data={this.state} onClick={this.onFirstSection}/>
                    }

                    {this.state.viewapproach &&
                        <Approach data={this.state} onClick={this.onFirstSection}/>
                    }
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    fetchPlayerIntervention,
    fetchPlayerCourse,
    fetchPlayerSamLab,
    fetchPlayerCaptoLab,
    fetchPlayerlaunch,
    fetchPlayerhack,
    fetchRangeIronPlay,
    fetchRangeFairway,
    fetchRangeDriver,
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay,
    fetchRangePutting,
    fetchPlayerFsIron,
    fetchPlayerFsDriver,
    fetchPlayerWedge,
    fetchPlayerSpeed,
    studentOCTBunkerPlay,
    studentOCTWedgePlay,
    studentOCTShortGame,
    studentOCTApproach,
})(FirstItem);
